import styled from "@emotion/styled";

export const FileInput = styled("input")`
  visibility: hidden;
  position: absolute;
`;
